import Swiper from 'swiper/dist/js/swiper';

import isIEbrowser from '../../../resources/scripts/helpers/is-ie';

class BrixImageCarousel {
  static init(...parameters) {
    return new BrixImageCarousel(...parameters);
  }

  constructor(selector) {
    this.selector = selector;
    const IE = isIEbrowser();
    this.swiperContainer = selector.querySelector('.swiper-container');
    this.swiperPagination = selector.querySelector('.swiper-pagination');
    this.swiperNext = selector.querySelector('.swiper-navigation-slide-next');
    this.swiperPrev = selector.querySelector('.swiper-navigation-slide-prev');
    this.swiperActiveSlide = selector.querySelector('.active-slide');
    this.swiperTotalSlides = selector.querySelector('.total-slides');

    const enableAutoplay = this.swiperContainer.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(this.swiperContainer.dataset.autoplayDelay, 10) * 1000;

    const brixCarousel = this;

    this.mySwiper = new Swiper(this.swiperContainer, {
      pagination: {
        el: this.swiperPagination,
        type: 'bullets',
        clickable: true,
        bulletElement: 'div',
      },
      navigation: {
        nextEl: this.swiperNext,
        prevEl: this.swiperPrev,
      },
      slidesPerView: 1,
      centeredSlides: true,
      autoplay: enableAutoplay ? { delay: autoplayDelay } : false,
      loop: true,
      on: {
        init() {
          brixCarousel.swiperActiveSlide.innerText = this.realIndex + 1;
        },
        slideChange() {
          brixCarousel.setCaption();
          brixCarousel.swiperActiveSlide.innerText = this.realIndex + 1;
        },
      },
    });

    if (this.mySwiper && IE) {
      window.objectFitPolyfill();
    }

    this.setCaption();

    this.maybeHideNavigation();

    window.addEventListener('resize', () => {
      // Render on resize to update swiper
      this.mySwiper.update();
      this.maybeHideNavigation();
    });
  }

  setCaption() {
    const captionElement = this.selector.querySelector('.slide-caption');
    if (!captionElement) return;
    const { activeIndex } = this.mySwiper;
    const activeSlide = this.mySwiper.slides[activeIndex];
    captionElement.innerText = activeSlide.dataset.caption;
    if (activeSlide.dataset.caption.length === 0) {
      captionElement.classList.add('-empty');
    } else {
      captionElement.classList.remove('-empty');
    }
  }

  maybeHideNavigation() {
    if (window.innerWidth < this.swiperContainer.offsetWidth + 24) {
      // not enough space for the navigation arrows
      this.swiperPrev.parentElement.classList.add('-hidden');
    } else {
      this.swiperPrev.parentElement.classList.remove('-hidden');
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-image-carousel', BrixImageCarousel.init);
}
